
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { isValidFloatNumber } from '@/helpers/isValidFloatNumber';
import { GammaSpecRnDetecModeEnum, GammaSpecRnDetecUnitEnum } from '@/modules/analysis/models/gammaSpecEnum';

export interface FormRnValue {
  isActive?: boolean;
  label: string;
  detectionMode: string;
  value: string;
  detectionUnit: string;
}

@Component({
  components: {}
})
export default class SpectroRadionuclideInput extends Vue {
  @Prop({ required: true })
  protected disabled!: boolean;
  @Prop({ required: true })
  protected value!: FormRnValue;
  protected checkboxValue = false;
  protected inputDetectionMode = '';
  protected inputValue = '';
  protected inputDetectionUnit = '';

  protected created(): void {
    this.setInitialValue();
  }

  protected verifyFloatNumber(value: string): boolean {
    return isValidFloatNumber(value);
  }

  @Watch('value', { immediate: true })
  protected setInitialValue(): void {
    this.checkboxValue = this.value.isActive || false;
    this.inputDetectionMode = this.value.detectionMode;
    this.inputValue = this.value.value;
    this.inputDetectionUnit = this.value.detectionUnit;
  }

  protected get gammaSpecRnDectecOptions(): { text: string; value: string }[] {
    return [
      {
        text: this.$i18n.t('common.gammaSpecDetectMode.threshold').toString(),
        value: GammaSpecRnDetecModeEnum.THRESHOLD
      },
      {
        text: this.$i18n.t('common.gammaSpecDetectMode.limit').toString(),
        value: GammaSpecRnDetecModeEnum.LIMIT
      }
    ];
  }

  protected get gammaSpecRnDectecUnits(): { text: string; value: string }[] {
    return [
      {
        text: this.$i18n.t('common.gammaSpecDetectUnit.bqkg').toString(),
        value: GammaSpecRnDetecUnitEnum.BQ_PER_KG
      },
      {
        text: this.$i18n.t('common.gammaSpecDetectUnit.bqg').toString(),
        value: GammaSpecRnDetecUnitEnum.BQ_PER_G
      },
      {
        text: this.$i18n.t('common.gammaSpecDetectUnit.bql').toString(),
        value: GammaSpecRnDetecUnitEnum.BQ_PER_L
      }
    ];
  }

  protected get radionuclide(): string {
    return this.value.label;
  }

  protected get currentInput(): FormRnValue {
    return {
      isActive: this.checkboxValue,
      label: this.radionuclide,
      detectionMode: this.inputDetectionMode,
      value: this.inputValue,
      detectionUnit: this.inputDetectionUnit
    };
  }
}
